import React from "react";
import './footer.css';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';

function Footer() {
    return (
        <div className="footer-container">
            <section className="footer-subscription">
            <div className="footer-link-wrapper">
                <div className="footer-links">
                    <div className="footer-link-items">
                        <div>
                            <h2>Located</h2>
                        </div>
                        <div className="footer-link-locations">
                            <p>Stockholm</p>
                            <p>Linköping</p>
                        </div>
                    </div>
                    <div className="footer-link-items">
                        <h2>Penny</h2>
                        <Link to='/aboutus'>Why & how it works</Link>
                        <Link to='/subscription'>Subscriptions</Link>
                        <Link to='/contact'>Partnerships</Link>
                        <Link to='/download'>App</Link>
                        
                    </div>
                    <div className="footer-link-contact">
                        <p>Want to work, partner or collaborate with us?</p>
                        <div className="footer-link-contact-links">
                            <div className="footer-link-contact-links-header">
                                <Link to='/contact'>Contact</Link>    
                            </div>
                            <div className="footer-link-contact-socials">
                            <Link 
                            className="social-icon-link linkedin" 
                                to='https://www.linkedin.com/in/marcosagredo/'
                                target='_blank'
                                aria-label='LinkedIn'
                                >
                                    <FontAwesomeIcon icon={faLinkedin}/>
                                </Link>
                            </div>
                        </div>
                        <div className="footer-link-items">
                            <Link 
                            to='/privacypolicy'>Privacy Policy</Link>
                            <Link 
                            to='/termsconditions'>Terms and Conditions</Link>
                        </div>
                    </div>
                    
                </div>
            </div>
            
            </section>
            <section className='social-media'>
                <div className='social-media-wrap'>
                    <div className='footer-logo'>
                        <Link to='/' className='social-logo'>
                        <img src='../images/Pennylogga.png' alt='Penny logo' /><h2>Save with Penny</h2>
                        </Link>
                        <p>Smart & easy way of saving®</p>
                    </div>
                
                    {/*<div className='social-icons'>
                        <Link 
                        className="social-icon-link facebook" 
                        to='/'
                        target='_blank'
                        aria-label='Facebook'
                        >
                            <FontAwesomeIcon icon={faFacebook}/>
                        </Link>
                        <Link 
                        className="social-icon-link instagram" 
                        to='/'
                        target='_blank'
                        aria-label='Instagram'
                        >
                            <FontAwesomeIcon icon={faInstagram}/>
                        </Link>
                        <Link 
                        className="social-icon-link twitter" 
                        to='/'
                        target='_blank'
                        aria-label='Twitter'
                        >
                            <FontAwesomeIcon icon={faTwitter}/>
                        </Link>
                        <Link 
                        className="social-icon-link linkedin" 
                        to='/'
                        target='_blank'
                        aria-label='LinkedIn'
                        >
                            <FontAwesomeIcon icon={faLinkedin}/>
                        </Link>
                    </div>*/}
                </div>
            </section>
        </div>
    );
}

export default Footer;